'use strict';

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A pure UI component which displays a username/password form.
 */
/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 Vector Creations Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var PasswordLogin = function (_React$Component) {
    (0, _inherits3.default)(PasswordLogin, _React$Component);

    function PasswordLogin(props) {
        (0, _classCallCheck3.default)(this, PasswordLogin);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordLogin.__proto__ || (0, _getPrototypeOf2.default)(PasswordLogin)).call(this, props));

        _this.state = {
            username: _this.props.initialUsername,
            password: _this.props.initialPassword,
            phoneCountry: _this.props.initialPhoneCountry,
            phoneNumber: _this.props.initialPhoneNumber,
            loginType: PasswordLogin.LOGIN_FIELD_MXID
        };

        _this.onForgotPasswordClick = _this.onForgotPasswordClick.bind(_this);
        _this.onSubmitForm = _this.onSubmitForm.bind(_this);
        _this.onUsernameChanged = _this.onUsernameChanged.bind(_this);
        _this.onUsernameBlur = _this.onUsernameBlur.bind(_this);
        _this.onLoginTypeChange = _this.onLoginTypeChange.bind(_this);
        _this.onPhoneCountryChanged = _this.onPhoneCountryChanged.bind(_this);
        _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind(_this);
        _this.onPhoneNumberBlur = _this.onPhoneNumberBlur.bind(_this);
        _this.onPasswordChanged = _this.onPasswordChanged.bind(_this);
        _this.isLoginEmpty = _this.isLoginEmpty.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PasswordLogin, [{
        key: 'onForgotPasswordClick',
        value: function onForgotPasswordClick(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            this.props.onForgotPasswordClick();
        }
    }, {
        key: 'onSubmitForm',
        value: function onSubmitForm(ev) {
            ev.preventDefault();

            var username = ''; // XXX: Synapse breaks if you send null here:
            var phoneCountry = null;
            var phoneNumber = null;
            var error = void 0;

            switch (this.state.loginType) {
                case PasswordLogin.LOGIN_FIELD_EMAIL:
                    username = this.state.username;
                    if (!username) {
                        error = (0, _languageHandler._t)('The email field must not be blank.');
                    }
                    break;
                case PasswordLogin.LOGIN_FIELD_MXID:
                    username = this.state.username;
                    if (!username) {
                        error = (0, _languageHandler._t)('The username field must not be blank.');
                    }
                    break;
                case PasswordLogin.LOGIN_FIELD_PHONE:
                    phoneCountry = this.state.phoneCountry;
                    phoneNumber = this.state.phoneNumber;
                    if (!phoneNumber) {
                        error = (0, _languageHandler._t)('The phone number field must not be blank.');
                    }
                    break;
            }

            if (error) {
                this.props.onError(error);
                return;
            }

            if (!this.state.password) {
                this.props.onError((0, _languageHandler._t)('The password field must not be blank.'));
                return;
            }

            this.props.onSubmit(username, phoneCountry, phoneNumber, this.state.password);
        }
    }, {
        key: 'onUsernameChanged',
        value: function onUsernameChanged(ev) {
            this.setState({ username: ev.target.value });
            this.props.onUsernameChanged(ev.target.value);
        }
    }, {
        key: 'onUsernameBlur',
        value: function onUsernameBlur(ev) {
            this.props.onUsernameBlur(ev.target.value);
        }
    }, {
        key: 'onLoginTypeChange',
        value: function onLoginTypeChange(ev) {
            var loginType = ev.target.value;
            this.props.onError(null); // send a null error to clear any error messages
            this.setState({
                loginType: loginType,
                username: "" // Reset because email and username use the same state
            });
        }
    }, {
        key: 'onPhoneCountryChanged',
        value: function onPhoneCountryChanged(country) {
            this.setState({
                phoneCountry: country.iso2,
                phonePrefix: country.prefix
            });
            this.props.onPhoneCountryChanged(country.iso2);
        }
    }, {
        key: 'onPhoneNumberChanged',
        value: function onPhoneNumberChanged(ev) {
            this.setState({ phoneNumber: ev.target.value });
            this.props.onPhoneNumberChanged(ev.target.value);
        }
    }, {
        key: 'onPhoneNumberBlur',
        value: function onPhoneNumberBlur(ev) {
            this.props.onPhoneNumberBlur(ev.target.value);
        }
    }, {
        key: 'onPasswordChanged',
        value: function onPasswordChanged(ev) {
            this.setState({ password: ev.target.value });
            this.props.onPasswordChanged(ev.target.value);
        }
    }, {
        key: 'renderLoginField',
        value: function renderLoginField(loginType) {
            var Field = _index2.default.getComponent('elements.Field');

            var classes = {};

            switch (loginType) {
                case PasswordLogin.LOGIN_FIELD_EMAIL:
                    classes.error = this.props.loginIncorrect && !this.state.username;
                    return _react2.default.createElement(Field, {
                        className: (0, _classnames2.default)(classes),
                        id: 'mx_PasswordLogin_email',
                        name: 'username' // make it a little easier for browser's remember-password
                        , key: 'email_input',
                        type: 'text',
                        label: (0, _languageHandler._t)("Email"),
                        placeholder: 'joe@example.com',
                        value: this.state.username,
                        onChange: this.onUsernameChanged,
                        onBlur: this.onUsernameBlur,
                        autoFocus: true
                    });
                case PasswordLogin.LOGIN_FIELD_MXID:
                    classes.error = this.props.loginIncorrect && !this.state.username;
                    return _react2.default.createElement(Field, {
                        className: (0, _classnames2.default)(classes),
                        id: 'mx_PasswordLogin_username',
                        name: 'username' // make it a little easier for browser's remember-password
                        , key: 'username_input',
                        type: 'text',
                        label: _SdkConfig2.default.get().disable_custom_urls ? (0, _languageHandler._t)("Username on %(hs)s", {
                            hs: this.props.hsUrl.replace(/^https?:\/\//, '')
                        }) : (0, _languageHandler._t)("Username"),
                        value: this.state.username,
                        onChange: this.onUsernameChanged,
                        onBlur: this.onUsernameBlur,
                        autoFocus: true
                    });
                case PasswordLogin.LOGIN_FIELD_PHONE:
                    {
                        var CountryDropdown = _index2.default.getComponent('views.auth.CountryDropdown');
                        classes.error = this.props.loginIncorrect && !this.state.phoneNumber;

                        var phoneCountry = _react2.default.createElement(CountryDropdown, {
                            value: this.state.phoneCountry,
                            isSmall: true,
                            showPrefix: true,
                            onOptionChange: this.onPhoneCountryChanged
                        });

                        return _react2.default.createElement(Field, {
                            className: (0, _classnames2.default)(classes),
                            id: 'mx_PasswordLogin_phoneNumber',
                            name: 'phoneNumber',
                            key: 'phone_input',
                            type: 'text',
                            label: (0, _languageHandler._t)("Phone"),
                            value: this.state.phoneNumber,
                            prefix: phoneCountry,
                            onChange: this.onPhoneNumberChanged,
                            onBlur: this.onPhoneNumberBlur,
                            autoFocus: true
                        });
                    }
            }
        }
    }, {
        key: 'isLoginEmpty',
        value: function isLoginEmpty() {
            switch (this.state.loginType) {
                case PasswordLogin.LOGIN_FIELD_EMAIL:
                case PasswordLogin.LOGIN_FIELD_MXID:
                    return !this.state.username;
                case PasswordLogin.LOGIN_FIELD_PHONE:
                    return !this.state.phoneCountry || !this.state.phoneNumber;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var Field = _index2.default.getComponent('elements.Field');

            var forgotPasswordJsx = void 0;

            if (this.props.onForgotPasswordClick) {
                forgotPasswordJsx = _react2.default.createElement(
                    'span',
                    null,
                    (0, _languageHandler._t)('Not sure of your password? <a>Set a new one</a>', {}, {
                        a: function a(sub) {
                            return _react2.default.createElement(
                                'a',
                                { className: 'mx_Login_forgot',
                                    onClick: _this2.onForgotPasswordClick,
                                    href: '#'
                                },
                                sub
                            );
                        }
                    })
                );
            }

            var signInToText = (0, _languageHandler._t)('Sign in to your Matrix account');
            if (this.props.hsName) {
                signInToText = (0, _languageHandler._t)('Sign in to your Matrix account on %(serverName)s', {
                    serverName: this.props.hsName
                });
            } else {
                try {
                    var parsedHsUrl = new URL(this.props.hsUrl);
                    signInToText = (0, _languageHandler._t)('Sign in to your Matrix account on %(serverName)s', {
                        serverName: parsedHsUrl.hostname
                    });
                } catch (e) {
                    // ignore
                }
            }

            var editLink = null;
            if (this.props.onEditServerDetailsClick) {
                editLink = _react2.default.createElement(
                    'a',
                    { className: 'mx_AuthBody_editServerDetails',
                        href: '#', onClick: this.props.onEditServerDetailsClick
                    },
                    (0, _languageHandler._t)('Change')
                );
            }

            var pwFieldClass = (0, _classnames2.default)({
                error: this.props.loginIncorrect && !this.isLoginEmpty() // only error password if error isn't top field
            });

            var loginField = this.renderLoginField(this.state.loginType);

            var loginType = void 0;
            if (!_SdkConfig2.default.get().disable_3pid_login) {
                loginType = _react2.default.createElement(
                    'div',
                    { className: 'mx_Login_type_container' },
                    _react2.default.createElement(
                        'label',
                        { className: 'mx_Login_type_label' },
                        (0, _languageHandler._t)('Sign in with')
                    ),
                    _react2.default.createElement(
                        Field,
                        {
                            className: 'mx_Login_type_dropdown',
                            id: 'mx_PasswordLogin_type',
                            element: 'select',
                            value: this.state.loginType,
                            onChange: this.onLoginTypeChange
                        },
                        _react2.default.createElement(
                            'option',
                            {
                                key: PasswordLogin.LOGIN_FIELD_MXID,
                                value: PasswordLogin.LOGIN_FIELD_MXID
                            },
                            (0, _languageHandler._t)('Username')
                        ),
                        _react2.default.createElement(
                            'option',
                            {
                                key: PasswordLogin.LOGIN_FIELD_EMAIL,
                                value: PasswordLogin.LOGIN_FIELD_EMAIL
                            },
                            (0, _languageHandler._t)('Email address')
                        ),
                        _react2.default.createElement(
                            'option',
                            {
                                key: PasswordLogin.LOGIN_FIELD_PHONE,
                                value: PasswordLogin.LOGIN_FIELD_PHONE
                            },
                            (0, _languageHandler._t)('Phone')
                        )
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h3',
                    null,
                    signInToText,
                    editLink
                ),
                _react2.default.createElement(
                    'form',
                    { onSubmit: this.onSubmitForm },
                    loginType,
                    loginField,
                    _react2.default.createElement(Field, {
                        className: pwFieldClass,
                        id: 'mx_PasswordLogin_password',
                        type: 'password',
                        name: 'password',
                        label: (0, _languageHandler._t)('Password'),
                        value: this.state.password,
                        onChange: this.onPasswordChanged
                    }),
                    forgotPasswordJsx,
                    _react2.default.createElement('input', { className: 'mx_Login_submit',
                        type: 'submit',
                        value: (0, _languageHandler._t)('Sign in'),
                        disabled: this.props.disableSubmit
                    })
                )
            );
        }
    }]);
    return PasswordLogin;
}(_react2.default.Component);

PasswordLogin.defaultProps = {
    onError: function onError() {},
    onEditServerDetailsClick: null,
    onUsernameChanged: function onUsernameChanged() {},
    onUsernameBlur: function onUsernameBlur() {},
    onPasswordChanged: function onPasswordChanged() {},
    onPhoneCountryChanged: function onPhoneCountryChanged() {},
    onPhoneNumberChanged: function onPhoneNumberChanged() {},
    onPhoneNumberBlur: function onPhoneNumberBlur() {},
    initialUsername: "",
    initialPhoneCountry: "",
    initialPhoneNumber: "",
    initialPassword: "",
    loginIncorrect: false,
    // This is optional and only set if we used a server name to determine
    // the HS URL via `.well-known` discovery. The server name is used
    // instead of the HS URL when talking about where to "sign in to".
    hsName: null,
    hsUrl: "",
    disableSubmit: false
};


PasswordLogin.LOGIN_FIELD_EMAIL = "login_field_email";
PasswordLogin.LOGIN_FIELD_MXID = "login_field_mxid";
PasswordLogin.LOGIN_FIELD_PHONE = "login_field_phone";

PasswordLogin.propTypes = {
    onSubmit: _propTypes2.default.func.isRequired, // fn(username, password)
    onError: _propTypes2.default.func,
    onForgotPasswordClick: _propTypes2.default.func, // fn()
    initialUsername: _propTypes2.default.string,
    initialPhoneCountry: _propTypes2.default.string,
    initialPhoneNumber: _propTypes2.default.string,
    initialPassword: _propTypes2.default.string,
    onUsernameChanged: _propTypes2.default.func,
    onPhoneCountryChanged: _propTypes2.default.func,
    onPhoneNumberChanged: _propTypes2.default.func,
    onPasswordChanged: _propTypes2.default.func,
    loginIncorrect: _propTypes2.default.bool,
    hsName: _propTypes2.default.string,
    hsUrl: _propTypes2.default.string,
    disableSubmit: _propTypes2.default.bool
};

module.exports = PasswordLogin;
//# sourceMappingURL=PasswordLogin.js.map